import { FuelPlanResponse } from "types";

export const withSelectedFuelStop = (
  fuelPlan: FuelPlanResponse,
  sequence: number,
  fuelStopId: string
): FuelPlanResponse => {
  const recommendation = fuelPlan.stops.find(
    (stop) => stop.sequence === sequence
  );
  const selectedFuelStop = recommendation?.fuelStops.find(
    (stop) => String(stop.id) === String(fuelStopId)
  );

  if (!recommendation || !selectedFuelStop) return fuelPlan;

  const selectionAlreadyApplied = recommendation.fuelStops.every(
    (stop) => stop.isDefault === (String(stop.id) === String(fuelStopId))
  );

  if (selectionAlreadyApplied) return fuelPlan;

  return {
    ...fuelPlan,
    stops: fuelPlan.stops.map((stop) =>
      stop.sequence === sequence
        ? {
            ...stop,
            fuelStops: stop.fuelStops.map((fuelStop) => ({
              ...fuelStop,
              isDefault: String(fuelStop.id) === String(fuelStopId),
            })),
          }
        : stop
    ),
  };
};
